import React, { useState, useEffect, useMemo } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchBarCP from '../components/SearchBarCP';  // Ensure correct import
import DateFormat from '../components/DateFormat';
import SubMenu from '../components/SubMenu';
import HeadingCp from '../components/HeadingCp';
import LoadingSpinner from '../components/LoadingSpinner';
import { CheckBadgeIcon } from '@heroicons/react/24/outline';
import Badge from '../components/Badge';

const BuildEstimateList = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [showVoid, setShowVoid] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [list, setList] = useState([]);
  const [estimate, setEstimate] = useState([]);
  const [filterEstimate, setFilterEstimate] = useState([]);
  const navigate = useNavigate();

  // ------------------------------------------------------------
  // modal visibility + the list that comes from /best_crud.php
  // ------------------------------------------------------------
  const [showBuilderModal, setShowBuilderModal] = useState(false);
  const [builderList,      setBuilderList]      = useState([]);  

  const [templateTypeFilter, setTemplateTypeFilter] = useState(''); 
  
  // ★ NEW – second-level filter
  const [manufacturerFilter, setManufacturerFilter] = useState('');


    // -----pagination---------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);  
  const [totalCount, setTotalCount] = useState(0);
  // -----pagination---------------------------------------------------

  const toggleShowVoid = () => {
    setShowVoid(!showVoid);
  };

  useEffect(() => {
    setLoading(true);
    const fetchBuilder = async () => {
      try {
        const response = await axios.get(`${apiUrl}/best_crud.php`, 
          {
            params: {
              list_builder: true
            }
          }, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        // console.log('Builder response:', response.data);
        if(response.data[0] === 'success') {
         setBuilderList(response.data[1] || []);
        }
        
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
        }
      } finally {
        setLoading(false);
      }
    };
      fetchBuilder();
 }, [apiUrl, navigate]);

  useEffect(() => {
    fetchEstimates(currentPage, itemsPerPage);
  }, [apiUrl, currentPage, itemsPerPage]);

  useEffect(() => { 
    setManufacturerFilter(''); 
  }, [templateTypeFilter]);

  const fetchEstimates = async (page = currentPage, limit = itemsPerPage) => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}/es_builder_crud.php`, {
        params: {
          listEsSystem: true,
          page,
          limit,
        },
      });
      setList(response.data.list || []);
      setEstimate(response.data.list || []);
      setFilterEstimate(response.data.list || []);
      setTotalCount(response.data.total_count || 0);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const openBuilderModal = async () => {
    // already fetched? open the modal immediately
    if (builderList.length) {
      setShowBuilderModal(true);
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/best_crud.php`, {
        params : { list_builder : true }
      });

      if (res.data[0] === 'success') {
        setBuilderList(res.data[1] || []);
        setShowBuilderModal(true);
      } else {
        toast.error('No templates returned.', { position:'top-center' });
      }
    } catch (err) {
      toast.error('Couldn’t fetch template list.', { position:'top-center' });
    } finally {
      setLoading(false);
    }
  };

  const handleSearchClick = async () => {
    setLoading(true);
    const bodyData = {
      status: 'search_estimate',
      data: { search: searchTerm }
    };
      try {
        const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
            headers: { 'Content-Type': 'application/json' },
          });         
         setList(response.data || []);
         setEstimate(response.data || []);
         setFilterEstimate(response.data || []);
      } catch (error) {
          if (error.response && error.response.status === 401) {
          navigate('/login');
          } else if (error.response && error.response.status === 403) {
          // setAccess(true);
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: "top-center"
          });
          }
      } finally {
        setLoading(false);
      }
  };


  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (value === '') {
      setFilterEstimate(estimate);
    } else {
      const filtered = estimate.filter(estimate =>
        (estimate.customer_name && estimate.customer_name.toLowerCase().includes(value.toLowerCase())) ||
        (estimate.job_number && estimate.job_number.toLowerCase().includes(value.toLowerCase())) ||
        (estimate.job_site && estimate.job_site.toLowerCase().includes(value.toLowerCase()))
      );
      setFilterEstimate(filtered);
    }
  };

  const handleCreateFromTemplate = async (templateId) => {
        navigate(`/b_estimate/${templateId}/new`);
    // try {
    //   /* Example: ask backend to clone template => new builder‑estimate
    //     Your endpoint / payload may differ. */
    //   const response = await axios.post(`${apiUrl}/best_crud.php`,
    //     { status: 'createEstimate', builder_id: templateId },
    //     { headers: { 'Content-Type': 'application/json' } }
    //   );

    //   if (response.data[0] === 'success') {
    //     toast.success('Estimate created!', { position:'top-center' });
    //     setShowBuilderModal(false);
    //     /* redirect user to the fresh estimate builder – adjust route as needed */
    //     navigate(`/build_estimate/${response.data[1].id}/${templateId}`);
    //   } else {
    //     toast.error(response.data.error || 'Could not create.', { position:'top-center' });
    //   }
    // } catch (err) {
    //   toast.error('Server error. Try again.', { position:'top-center' });
    // }
  };

  const handleApproval = async (id) => {
    setLoading(true);
    const bodyData = {
      status: "approveEstimate",
      estimate_id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });   
      if (response.data.success) {
            setFilterEstimate(prevItems =>
              prevItems.map(item =>
                item.id === id ? { ...item, approved: true} : item // Set TECH to full name
              )
            );
        toast.success('Reviewed Estimate!', {  position: 'top-center', });
      } else {
        toast.info("Failed approval.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleApprovalRemove = async (id) => {
    setLoading(true);
    const bodyData = {
      status: "approveEstimateRemove",
      estimate_id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });   
      if (response.data.success) {
            setFilterEstimate(prevItems =>
              prevItems.map(item =>                
                item.id === id ? { ...item, approved: false} : item // Set TECH to full name
              )
            );
        toast.success('Approval Removed!', {  position: 'top-center', });
      } else {
        toast.info("Failed removal.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleVoid = async (id) => {
    setLoading(true);
    const bodyData = {
      status: "voidEstimate",
      estimate_id: id,
    };
    console.log(bodyData);
    
    try {
      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });   
        console.log('Voided estimate ID:', response.data);

      if (response.data.success) {
            setFilterEstimate(prevItems =>
              prevItems.map(item =>                
                item.id === id ? { ...item, status: 'void'} : item // Set TECH to full name
              )
            );
        toast.success('Voided Estimate!', {  position: 'top-center', });
      } else {
        toast.info("Failed voiding.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveVoid = async (id) => {
    setLoading(true);
    const bodyData = {
      status: "removeVoidEstimate",
      estimate_id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });   
      if (response.data.success) {
            setFilterEstimate(prevItems =>
              prevItems.map(item =>                
                item.id === id ? { ...item, status: ''} : item // Set TECH to full name
              )
            );
        toast.success('Voided Estimate!', {  position: 'top-center', });
      } else {
        toast.info("Failed voiding.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRevision = async (id) => {
    setLoading(true);
    const bodyData = {
      status: "addRevision",
      estimate_id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });   
      if (response.data.success) {
            // setFilterEstimate(prevItems =>
            //   prevItems.map(item =>                
            //     item.id === id ? { ...item, revision: item.revision + 1} : item // Set TECH to full name
            //   )
            // );
            fetchEstimates()
        toast.success('Added Revision!', {  position: 'top-center', });
      } else {
        toast.info("Failed adding revision.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {     
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };    

  const handleRequestProposal = async (id) => {
    setLoading(true);
    const bodyData = {
      status: "requestProposal",
      estimate_id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });   
      if (response.data.success) {
        toast.success('Approval Requested!', {  position: 'top-center', });
      } else {
        toast.info("Failed requesting approval.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // ------------------------------------------------------------

  const getLinksForJob = (estimate) => {
    let links = [
      { name: 'Edit Estimate', click:() => navigate(`/b_estimate/${estimate.es_builder_estimate_id}/${estimate.id}`) },
      // { name: 'Equipments', click:() => navigate(`/estimate_equipment/${estimate.id}`) },
      // { name: 'Detail', click:() => navigate(`/estimate_detail/${estimate.id}`) },
      { name: 'View Proposal', click: () => navigate(`/estimate_proposal/${estimate.es_builder_estimate_id}/${estimate.id}`) },
      // { name: 'Generate estimate-Number', click:() => navigate(`#`) },
      // { name: 'Generate Estimate Job-Number(ND)', click:() => navigate(`#`) },
    ];

    if (estimate.approved) {
      links.push( { name: 'Remove Ready', click: () => handleApprovalRemove(estimate.id), key: `approveRemove-${estimate.id}`});
      // links.push( { name: 'Request Proposal', click: () => handleRequestProposal(estimate.id), key: `approveRequest-${estimate.id}`});
    } else {
      if (estimate.status === 'void') {
        links.push( { name: 'Remove Void', click: () => handleRemoveVoid(estimate.id), key: `void-${estimate.id}`});
      } else {
        if(estimate.revisedID === 0 || estimate.revisedID === null){
         links.push( { name: 'Add Revision', click: () => handleRevision(estimate.id), key: `revision-${estimate.id}`});
         links.push( { name: 'Void Estimate', click: () => handleVoid(estimate.id), key: `void-${estimate.id}`});
        }
        links.push( { name: 'Reviewed Estimate', click: () => handleApproval(estimate.id), key: `invoicex-${estimate.id}`});
      }      
    }



    return links;
  };

  const templateTypes = useMemo(() => {
    const types = new Set(builderList.map((tpl) => tpl.estimate_type));
    return Array.from(types);
  }, [builderList]);

 const manufacturers = useMemo(() => {
   const src = templateTypeFilter
                ? builderList.filter(t => t.estimate_type === templateTypeFilter)
                : builderList;
   return Array.from(new Set(src.map(t => t.manufacture).filter(Boolean)));
 }, [builderList, templateTypeFilter]);  

 const filteredBuilderList = useMemo(() => {
   let list = builderList;
   if (templateTypeFilter)
     list = list.filter(t => t.estimate_type === templateTypeFilter);
   if (manufacturerFilter)
     list = list.filter(t => t.manufacture    === manufacturerFilter);
   return list;
 }, [builderList, templateTypeFilter, manufacturerFilter]); 

  // const totalPages = Math.ceil(filterEstimate.length / itemsPerPage);
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]); 

return (
    <>
      <div className="mx-auto max-w-[1250px] px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center sm:justify-between">
          <div className="sm:flex-auto mt-8 mb-5">
            <HeadingCp label={'Estimate Project List'} />
          </div>
        </div>
        <div className="-mx-4 mt-8">
          <div className="mt-5 sm:mt-0 sm flex space-x-3 items-center mb-10">
            
              <button
                type="button"
                onClick={openBuilderModal}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
              >
                New Estimate +
              </button>
            
            <SearchBarCP search={searchTerm} handleChange={handleSearchChange} onClick={handleSearchClick} />
          </div>
          <div className="tableContainer">
            {loading ? (
              <LoadingSpinner>Loading....</LoadingSpinner>
            ) : (
              <>
                {filterEstimate.length > 0 ? 
                (
                  <table className="min-w-full divide-y divide-x divide-gray-300 bg-gray-200 border rounded-lg divide-x">
                    <thead>
                      <tr className="divide-x divide-gray-400">
                        <th className=" px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Menu ID</th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Date</th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Sales / Job#</th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Bidding Address</th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Attention</th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Company</th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Rv</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {filterEstimate.map((estimate, index) => (
                        <tr key={estimate.id} 
                            className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}, 
                            ${estimate.status === 'void' ? 'line-through text-red-500' : ''} 
                            ${estimate.revision > 0 ? 'bg-blue-200 text-red-500' : ''} 
                            divide-x`}>
                          <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                            <div><SubMenu label={estimate.id} idItem={estimate.id} links={getLinksForJob(estimate)} /></div>
                            {estimate.approved && (
                            <div>
                              <Badge color="green" feed="Ready for Review" />
                            </div>
                            )}   
                          </td>

                          <td className="px-3 py-4 text-sm text-gray-500 lg:table-cell">                            
                            <DateFormat date={estimate.date} />
                          </td>

                          <td className="px-3 py-4 text-sm text-gray-500">
                            {estimate.user_id}
                          </td>

                          <td className="px-3 py-4 text-sm text-gray-500">
                            {estimate.bidding_address}
                          </td>

                          <td className="px-3 py-4 text-sm text-gray-500">
                            {estimate.att}
                          </td>

                          <td className="px-3 py-4 text-sm text-gray-500">
                            <p className="text-gray-800 font-bold">{estimate.contact_name}</p>
                            <p className="text-xs">{estimate.contact_address}</p>
                            <p className="text-xs">{estimate.contact_city} {estimate.contact_state} {estimate.contact_zip}</p>
                            <p className="text-xs">{estimate.contact_phone}</p>
                            <p className="text-xs">{estimate.contact_email}</p>
                          </td>

                          <td className="px-3 py-4 text-sm text-gray-500">
                            {estimate.revision > 0 ? (
                              <div className="inline-flex items-center space-x-2 text-blue-700">
                                <span>Revision</span>
                                <span>{estimate.revision}</span>
                              </div>
                              ) : ( '' )}
                            {estimate.revisedID > 0 ? (
                              <>
                              <br/>
                              <div className="inline-flex items-center space-x-2 text-purple-700">
                                <span>Revised from ID</span>
                                <span>{estimate.revisedID}</span>
                              </div>
                              </>
                              ) : ( '' )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : ( 'No data' )}
                {filterEstimate.length > 0 && (
                  <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3">
                    <div className="flex items-center gap-2 text-sm text-gray-700">
                      <span>Rows per page:</span>
                      <select
                        value={itemsPerPage}
                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                        className="rounded-md border-gray-300 text-sm"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>

                    <div className="flex items-center gap-3">
                      <span className="text-sm text-gray-700">
                        Page {currentPage} of {totalPages || 1}
                      </span>

                      <button
                        type="button"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                        className="rounded-md border border-gray-300 px-3 py-1 text-sm disabled:opacity-50"
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        disabled={currentPage === totalPages || totalPages === 0}
                        onClick={() => setCurrentPage((page) => Math.min(page + 1, totalPages))}
                        className="rounded-md border border-gray-300 px-3 py-1 text-sm disabled:opacity-50"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}                  
              </>
            )}
          </div>
        </div>
        {/* ---------------- Template‑Picker Modal ---------------- */}
        {showBuilderModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded shadow-lg w-full max-w-md p-6 relative">
              {/* close X */}
              <button
                className="absolute top-2 right-3 text-gray-500 hover:text-gray-800"
                onClick={() => setShowBuilderModal(false)}
              >
                ×
              </button>

              <h3 className="text-lg font-semibold mb-4">Choose a template</h3>

              {/* --- FILTER DROPDOWN --- */}
              <div className="mb-4">
                <label htmlFor="templateType" className="block text-sm font-medium text-gray-700">
                  Show by Type
                </label>
                <select
                  id="templateType"
                  value={templateTypeFilter}
                  onChange={(e) => setTemplateTypeFilter(e.target.value)}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option value="">All Types</option>
                  {templateTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              {/* ★ NEW  Manufacturer dropdown – shows only after a type is chosen */}
              {templateTypeFilter && manufacturers.length > 0 && (
                <div className="mb-4">
                  <label htmlFor="mfgr" className="block text-sm font-medium text-gray-700">
                    Manufacturer
                  </label>
                  <select
                    id="mfgr"
                    value={manufacturerFilter}
                    onChange={(e)=>setManufacturerFilter(e.target.value)}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm
                                focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    <option value="">All Manufacturers</option>
                    {manufacturers.map(m => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                </div>
              )}            

              {loading && <p>Loading…</p>}
              {!loading && filteredBuilderList.length === 0 && (
                <p className="text-sm text-gray-500">No templates available.</p>
              )}

              {!loading && filteredBuilderList.length > 0 && (
                <ul className="space-y-2 max-h-72 overflow-y-auto pr-1">
                  {filteredBuilderList.map((tpl) => (
                    <li key={tpl.id} className="bg-gray-50 border rounded px-3 py-2">
                      <div className="flex items-center justify-between">
                        <span className="font-medium">{tpl.estimate_name}</span>
                        <button
                          onClick={() => handleCreateFromTemplate(tpl.id)}
                          className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700" >
                          Create
                        </button>
                      </div>
                      <p className="text-xs text-gray-500">{tpl.full_description}</p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BuildEstimateList;
